import type { QueryClient } from '@tanstack/react-query';
import type { Effect } from 'effect';
import { getUserProfileEffect, userProfileQueryKey } from './user';

export const buildUserProfileLifecycle = (
  client: QueryClient,
  beforeProfileRefetch?: () => Promise<unknown>,
) => ({
  onSuccess: async (profile: Effect.Success<typeof getUserProfileEffect>) => {
    client.setQueryData(
      userProfileQueryKey,
      (old: Effect.Success<typeof getUserProfileEffect> | undefined) => ({
        ...old,
        ...profile,
      }),
    );
    if (beforeProfileRefetch) {
      const refreshed = await beforeProfileRefetch().then(
        () => true,
        () => false,
      );
      if (!refreshed) return;
    }
    return client.invalidateQueries({ queryKey: userProfileQueryKey });
  },
});
